import Scrollbar from './src/index.vue'

export default Scrollbar
